import { createResource } from 'react-resource-router';

type BlackDuckComponent = {
  name: string;
  details: string;
};
type BlackDuckLicense = {
  name: string;
  components: string;
  text: string;
};
export type BlackDuckResponse = {
  components: BlackDuckComponent[];
  licenses: BlackDuckLicense[];
};

const fetchPackages = async (source: string) => {
  try {
    const response = await fetch(
      `https://bbc-object-storage--frontbucket.us-east-1.prod.public.atl-paas.net/licenses/${source}`
    );
    if (source.includes('json')) {
      return response.json();
    }
    return response.text();
  } catch {
    // eslint-disable-next-line no-console
    console.error(`${source} licenses not found`);
    return [];
  }
};

const parseBlackDuckResponse = (text: string): BlackDuckResponse => {
  const components: BlackDuckComponent[] = [];
  const licenses: BlackDuckLicense[] = [];

  const [startText, licenseText] = text.split(/Licenses:\s*/);
  const [_, componentText] = startText.split(/Components:\s*/);
  for (const line of componentText.split('\n').filter(Boolean)) {
    const trimmedLine = line.trim();
    if (!trimmedLine) {
      continue;
    }
    const [name, ...others] = trimmedLine.split(':');
    components.push({
      name,
      details: others.join(':').trim(),
    });
  }
  const licenseList = licenseText.split(/(\n|^)---(\r|\n)/);
  for (const line of licenseList) {
    const trimmedLine = line.trim();
    if (!trimmedLine) {
      continue;
    }
    const [name, licenseComponents, ...others] = trimmedLine.split(/\r/);
    licenses.push({
      name,
      components: licenseComponents.trim(),
      text: others.join('').trim(),
    });
  }

  return {
    components,
    licenses,
  };
};

// eslint-disable-next-line import/no-default-export
export default createResource({
  type: 'global',
  getKey: () => 'attributions',
  maxAge: 30 * 1000,
  getData: async (): Promise<BlackDuckResponse> => {
    const blackduck = await fetchPackages('frontbucket-bd.txt');
    return parseBlackDuckResponse(blackduck);
  },
});
